<template>
    <el-drawer
        :title="`${item.id ? '编辑':'新增'}角色`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="800px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form" label-position="top">
                <el-form-item label="角色名称" v-check="{'必填': !form.name}">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="选择分类" v-check="{'必选': !form.categoryIdArray}">
                    <el-checkbox-group v-model="form.categoryIdArray">
                        <el-checkbox v-for="item in categories" :key="item.id" :label="item.id">
                            {{item.name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="标签">
                    <el-select
                        style="width: 100%"
                        v-model="form.tags"
                        multiple
                        filterable
                        allow-create
                        default-first-option
                        placeholder="请选择文章标签">
                        <el-option
                            v-for="item in tags"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <div slot="label">
                        <span>添加造型</span>
                        <el-autocomplete
                            style="margin-left: 20px;width: 500px"
                            v-model="costume_search"
                            value-key="name"
                            prefix-icon="el-icon-search"
                            :trigger-on-focus="false"
                            popper-class="material-autocomplete"
                            :fetch-suggestions="queryCostumeSearch"
                            placeholder="输入关键字从造型库中选取"
                            @select="handleCostumeSelect">
                            <i
                                class="el-icon-close el-input__icon"
                                slot="suffix"
                                @click.stop="costume_search=''">
                            </i>
                            <template slot-scope="{ item }">
                                <div class="fx fx-m_start fx-c_start">
                                    <div class="material_cover fx fx-center">
                                        <img :src="item.url" >
                                    </div>
                                    <div>
                                        <div class="material_name">名称：{{ item.name }}</div>
                                        <span class="material_sn">编号：{{ item.sn }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-autocomplete>
                    </div>
                    <div class="fx fx-m_start fx-wrap photo_uploader">

                        <div class="el-upload" v-for="(item, i) in costumes" :key="i">
                            <span class="material_label">{{item.name}}</span>
                            <el-popconfirm @onConfirm="del(costumes, i)"
                                           title="确认删除该造型吗？"
                            >
                                <i slot="reference" class="el-icon-error text_danger font24 del_btn"></i>
                            </el-popconfirm>
                            <img :src="item.url" class="img">
                        </div>
                    </div>
                </el-form-item>
                <el-form-item >
                    <div slot="label">
                        <span>添加声音</span>
                        <el-autocomplete
                            style="margin-left: 20px;width: 500px"
                            v-model="sound_search"
                            value-key="name"
                            prefix-icon="el-icon-search"
                            :trigger-on-focus="false"
                            popper-class="material-autocomplete"
                            :fetch-suggestions="querySoundSearch"
                            placeholder="输入关键字从声音库中选取"
                            @select="handleSoundSelect">
                            <i
                                class="el-icon-close el-input__icon"
                                slot="suffix"
                                @click.stop="sound_search=''">
                            </i>
                            <template slot-scope="{ item }">
                                <div class="fx fx-m_start fx-c_start">
                                    <div class="material_cover fx fx-center">
                                        <i class="el-icon-message-solid font24"></i>
                                    </div>
                                    <div>
                                        <div class="material_name">名称：{{ item.name }}</div>
                                        <span class="material_sn">编号：{{ item.sn }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-autocomplete>
                    </div>
                    <div class="fx fx-m_start fx-wrap photo_uploader">

                        <div class="el-upload" v-for="(item, i) in sounds" :key="i">
                            <span class="material_label">{{item.name}}</span>
                            <el-popconfirm @onConfirm="del(sounds, i)"
                                           title="确认删除该声音吗？"
                            >
                                <i slot="reference" class="el-icon-error text_danger font24 del_btn"></i>
                            </el-popconfirm>
                            <i class="el-icon-message-solid text_info" style="font-size: 50px"></i>
                        </div>
                    </div>
                </el-form-item>
            </el-form>

        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>
<style>
</style>
<style scoped>
    .el-upload {
        margin-bottom: 10px;
    }
    .img {
        max-width: 200px;
        max-height: 200px;
    }
    .del_btn {
        position: absolute;
        bottom: 3px;
        right: 5px;
    }
    .material_label {
        position: absolute;
        bottom: 0;
        height: 30px;
        line-height: 30px;
        text-align: center;
        left: 0;
        right: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        background: #f0f0f0;
    }
    .material_cover {
        width: 75px;
        height: 85px;
        margin-right: 10px;
    }
    .material_cover img{
        max-height: 100%;
        max-width: 100%;
    }
    .material_name {
        padding-top: 10px;
    }
    .material_sn {
        font-size: 12px;
        color: #b4b4b4;
    }

</style>


<script>


    export default {
        props: [
            "item",
            "itemCostumes",
        ],
        data() {
            return {
                show: true,
                costume_search: "",
                sound_search: "",
                tags:[],

                form: {categoryIdArray:[],relatedMaterials:[]},
                sounds: [],
                costumes: [],
                categories: [],
                relatedMaterials:[]
            }

        },
        watch: {
            item:  {
                handler: function (newValue) {
                    this.form = {...this.item,
                        tags: this.item.tagArray ? this.item.tagArray : [],
                        categoryIdArray: this.item.categoryIdArray ? this.item.categoryIdArray : [],
                        type: 1
                    }
                    console.log(this.form)
                    this.sounds = [];
                    this.costumes = [];
                    this.loadRelateds();
                },
                immediate: true
            },
            itemCostumes: {
                handler: function (newValue) {
                    if(this.item.id == undefined){
                        this.relatedMaterials.push(this.itemCostumes);//直接push form的报错
                        // this.form = this.itemCostumes;
                        this.form = {
                            tags: this.itemCostumes.tagArray ? this.itemCostumes.tagArray : [],
                            categoryIdArray: this.itemCostumes.categoryIdArray ? this.itemCostumes.categoryIdArray : [],
                            type: 1,
                            name:this.itemCostumes.name
                        }
                        this.form.relatedMaterials = this.relatedMaterials;
                        this.loadRelateds();
                    }

                },
                immediate: true
            },
        },


        methods: {
            //从库中搜索
            queryCostumeSearch(keywords, cb) {
                if (!keywords || !keywords.trim()) {
                    cb([]);
                } else {
                    this.$ajaxPost("/material/listBySchool", {
                        form: {
                            keywords: keywords,
                            type: 2
                        },
                        pager: {
                            offset: 0,
                            pageSize: 10,
                        }
                    }, data => {
                        cb(data.result);
                    })
                }
            },
            querySoundSearch(keywords, cb) {
                if (!keywords || !keywords.trim()) {
                    cb([]);
                } else {
                    this.$ajaxPost("/material/listBySchool", {
                        form: {
                            keywords: keywords,
                            type: 4
                        },
                        pager: {
                            offset: 0,
                            pageSize: 10,
                        }
                    }, data => {
                        cb(data.result);
                    })
                }
            },
            handleCostumeSelect(item) {

                let exists = this.costumes.filter(c => c.id == item.id).length > 0;
                if (exists ) {
                    this.$showError("已选取，不可重复选取");
                } else {
                    this.costumes.push(item);
                }
                this.costume_search = "";
            },
            handleSoundSelect(item) {
                let exists = this.sounds.filter(c => c.id == item.id).length > 0;
                if (exists ) {
                    this.$showError("已选取，不可重复选取");
                } else {
                    this.sounds.push(item);
                }
                this.sound_search = "";
            },
            analysePic() {
                let img = this.$refs.img;
                this.form.info = JSON.stringify([img.naturalWidth, img.naturalHeight, img.getAttribute("src").endsWith("svg") ? 1 : 2])
            },

            sub() {
                this.$checkForm(this.$refs.form).then(success => {
                    if (success) {
                        //校验通过，干什么....
                       let costumeIds = this.costumes.map(item => item.id);
                        let soundIds = this.sounds.map(item => item.id);

                        this.$ajaxPost("/material/save", {
                            material: {
                                ...this.form,
                                tags: this.form.tags.join(","),
                                categories: this.form.categoryIdArray.join(','),
                                costumeIds: costumeIds,
                                soundIds: soundIds,
                                info: JSON.stringify([0, costumeIds.length, soundIds.length])
                            }
                        }, data => {
                            this.$showSuccess("保存成功", 1200, () => {
                                this.$emit("submit");
                            })
                        })
                        return false;
                    } else {
                        this.$showError("请输入内容再保存");
                    }
                })
            },

            loadCategories() {
                //分类上，造型和角色用一个分类
                this.$ajaxGet("/materialCategory/list/1-true", data => {
                    this.categories = data.result;
                })
            },

            loadRelateds() {
                this.sounds = this.form.relatedMaterials ? this.form.relatedMaterials.filter(i => i.type == 4) : [];
                this.costumes = this.form.relatedMaterials ? this.form.relatedMaterials.filter(i => i.type == 2) : [];
            },
            close() {
                this.$emit("close");
            },
            del(item, i) {
                item.splice(i,  1);
            },
            /**
             * 加载标签
             */
            loadTags() {
                this.$ajaxGet("/material/listTags", data => {
                    this.tags = data.result ? data.result.map(item => item.name) : [];
                })
            }

        },
        mounted() {
            this.loadCategories();
            this.loadRelateds();
            this.loadTags();
        },



    }
</script>
